<template>
  <div class="pagination-container">
    <span class="pagination-info">{{ paginationInfo }}</span>
    <div class="pagination-controls">
      <button 
        :disabled="currentPage === 1" 
        @click="$emit('previous-page')"
        class="pagination-btn"
      >
        Previous
      </button>
      <button 
        :disabled="isLastPage" 
        @click="$emit('next-page')"
        class="pagination-btn"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaginationControls',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    isLastPage: {
      type: Boolean,
      required: true
    },
    paginationInfo: {
      type: String,
      required: true
    }
  },
  emits: ['previous-page', 'next-page']
};
</script>

<style scoped>
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}

.pagination-info {
  color: #6b7280;
  font-size: 14px;
}

.pagination-controls {
  display: flex;
  gap: 8px;
}

.pagination-btn {
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  background: white;
  border-radius: 6px;
  cursor: pointer;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>